import { Plugin } from 'vue'
import { createHead } from '@unhead/vue/client'
import { useHead, UseHeadInput } from '@unhead/vue'

type HeadOption = UseHeadInput | ((this: any) => UseHeadInput)

declare module 'vue' {
  interface ComponentCustomOptions {
    /** Document head (title etc.) for as long as the component is mounted; the deepest component wins */
    head?: HeadOption
  }
}

/**
 * Applies each component's `head` option through unhead.
 * Unlike unhead's own VueHeadMixin, this also picks up `head` from mixins (e.g. entity-landing.mixin).
 */
export default {
  install(app) {
    app.use(createHead())
    app.mixin({
      created() {
        const head: HeadOption = this.$options.head
        if (head) {
          useHead((typeof head === 'function' ? () => head.call(this) : head) as UseHeadInput)
        }
      },
    })
  },
} as Plugin
